export default __webpack_public_path__ + "static/media/chevron-down.baa2be32.svg";